import axiosInstance from "@/api/axiosInstance";
import type {
  CallSettings,
  UpdateCallSettingsPayload,
  CallSettingsResponse,
} from "./types";

const BASE_URL = "/api/private/transcription-settings/global";

/**
 * Fetch the current call settings for the company
 */
export const getCallSettings = async (): Promise<CallSettings> => {
  const response = await axiosInstance.get<CallSettings>(BASE_URL);
  return response.data;
};

/**
 * Update the call settings for the company
 */
export const updateCallSettings = async (
  payload: UpdateCallSettingsPayload,
): Promise<CallSettingsResponse> => {
  const response = await axiosInstance.put<CallSettingsResponse>(
    BASE_URL,
    payload,
  );
  return response.data;
};
